var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-0 ma-0 text"},_vm._l((_vm.getList),function(text,idx){return (_vm.params.data.competence)?_c('div',{key:idx},[_vm._v(_vm._s(text))]):_vm._e()}),0)}
var staticRenderFns = []

export { render, staticRenderFns }